
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.55,"time":33000,"words":110}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className="column">
      <h2 {...{
        "id": "le-programme-portic"
      }}>{`Le programme PORTIC`}</h2>
      <p>{`Le programme de recherche PORTIC (ANR-18-CE38–0010) se propose de croiser les données sur la navigation et sur la valeur du commerce étranger de la France à la veille de la Révolution française pour mieux saisir les dynamiques commerciales à l’œuvre. Pour ce faire, il offre des interfaces d’interrogation et de visualisation des données adaptées à des publics et des intérêts variés.`}</p>
      <p><a parentName="p" {...{
          "href": "https://anr.portic.fr/"
        }}>{`En savoir plus sur le programme PORTIC`}</a></p>
    </div>
    <div className="column">
      <p>{`Les contenus de ce site sont placés sous `}<a parentName="p" {...{
          "href": "https://creativecommons.org/licenses/by-nc-sa/3.0/fr/"
        }}>{`licence libre creative commons CC-BY-SA-NC`}</a>{`.`}</p>
      <p>{`Le code source de ce site est placé sous licence libre `}<a parentName="p" {...{
          "href": "https://www.gnu.org/licenses/agpl-3.0.fr.html"
        }}>{`AGPL-3.0`}</a>{`.`}</p>
      <p><a parentName="p" {...{
          "href": "https://github.com/medialab/portic-storymaps-2021/"
        }}>{`Accéder au code source de ce site`}</a></p>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "le-programme-portic",
    level: 2,
    title: "Le programme PORTIC",
    children: [
        
      ]
  }
]

export const frontMatter = {}

